import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Icon,
} from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function DeleteTemplateModal({
  isOpen,
  onCloseRequest,
  data,
  onDeleteRequest,
}) {
  const { id, template_name, tag } = data;
  
  const deleteTemplateModalTitle = useGlotaT('spa.certification.deleteTemplateModalTitle');
  const deleteTemplateModalPermanent = useGlotaT('spa.certification.deleteTemplateModalPermanent');
  const deleteTemplateModalConfirm = useGlotaT('spa.certification.deleteTemplateModalConfirm');
  const deleteTemplateModalWarning = useGlotaT('spa.certification.deleteTemplateModalWarning');
  const deleteTemplateModalBack = useGlotaT('spa.certification.deleteTemplateModalBack');
  const deleteTemplateModalDelete = useGlotaT('spa.certification.deleteTemplateModalDelete');

  function handleDeleteClick() {
    onDeleteRequest(id ? id : template_name);
    onCloseRequest();
  }

  const styles = {
    title: {
      fontSize: '3rem',
      margin: 'auto',
      fontWeight: '700',
      overflow: 'hidden',
    },
    attention: {
      fontSize: '1.75rem',
      fontWeight: '700',
      marginLeft: '10px',
      textAlign: 'center',
    },
    warning: {
      fontSize: '0.8rem',
      fontWeight: '700',
      color: 'var(--danger)',
    },
  }

  return (
    <Modal isOpen={isOpen} toggle={onCloseRequest}>
      <div>
        <h5 style={styles.attention}>{deleteTemplateModalTitle}</h5>
        <ModalHeader toggle={onCloseRequest}>
          <Icon
            icon="poli-icon pi-delete-fill"
            size={40}
            color={`var(--danger)`}
          />
          <span style={styles.title}>{tag}</span>
        </ModalHeader>
      </div>
      <ModalBody>
        <span>{deleteTemplateModalPermanent}</span>
        <p>{deleteTemplateModalConfirm}</p>
        <p style={styles.warning}>{deleteTemplateModalWarning}</p>
      </ModalBody>
      <ModalFooter>
        <Button outline onClick={onCloseRequest} size="lg">
          {deleteTemplateModalBack}
        </Button>
        <Button color="danger" size="lg" onClick={handleDeleteClick}>
          {deleteTemplateModalDelete}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteTemplateModal;
